import type { UserSearchResponseUsersItem } from './userSearchResponseUsersItem';

export interface UserSearchResponse {
  query?: string;
  totalResults?: number;
  users?: UserSearchResponseUsersItem[];
}
